import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Button from '../Button/index.js';
import CloseButton from '../CloseButton/index.js';
import Glyphicon from '../Glyphicon/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Toast(_ref) {
  let {
    show = false,
    position = 'top',
    speed = 'quick',
    heading,
    body = '',
    uiContext = 'confirmation',
    onButtonClick,
    onDismiss = () => {},
    className
  } = _ref;
  let glyphName;
  let buttonLabel = '';
  switch (uiContext) {
    case 'error':
      glyphName = 'danger';
      buttonLabel = 'Retry';
      break;
    case 'info':
      glyphName = 'info';
      break;
    default:
      glyphName = 'check-circle';
      buttonLabel = 'Undo';
  }
  const [isActive, setIsActive] = useState(show);
  const handleClick = () => {
    onDismiss();
    setIsActive(false);
  };
  const rootClassName = clsx('toast display-flex flex-row justify-content-center', {
    'slide-enter-exit-top': isActive && position === 'top',
    'slide-enter-exit-bottom': isActive && position === 'bottom'
  }, position, speed, className);
  return isActive && /*#__PURE__*/_jsxs("div", {
    "data-cmp": "toast",
    className: rootClassName,
    children: [/*#__PURE__*/_jsx("div", {
      className: "toast-icon display-flex align-items-center padding-left-2 padding-vertical-4",
      children: /*#__PURE__*/_jsx(Glyphicon, {
        glyph: glyphName,
        className: "text-size-700"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "padding-vertical-4",
      style: {
        flex: '1 1 auto'
      },
      children: [heading && /*#__PURE__*/_jsx("h3", {
        className: "toast-heading",
        children: heading
      }), body, !!onButtonClick && /*#__PURE__*/_jsx(Button, {
        bsStyle: "text-decorated-inverse",
        className: "margin-left-1",
        onClick: onButtonClick,
        "aria-label": buttonLabel,
        children: buttonLabel
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "padding-horizontal-2 padding-top-3",
      children: /*#__PURE__*/_jsx(CloseButton, {
        onClick: handleClick,
        inverse: true
      })
    })]
  });
}
export default Toast;